/* 
* HOW TO USE:
* If you need to add an data attribute to an element in the block editor
* add the class "pd_data" - this tags it to be included in the following function
* then add a class with the following structure:
* pd_data-{attribute name}_{attribute value}
* The transformer will split the class on underscores and transform it into a data attribute
*/

const DataAttrTransformer = () => {

  // Hack to allow controlling smooth scroller and other attribute driven libraries through gutenberg classnames
  
  const targets = document.querySelectorAll('.pd_data')

  const isMatch = (str) => {
    var matchedAttr = null;
    var attrPrefix = 'pd_data-';
    if (String(str).includes(attrPrefix)){
      matchedAttr = str.split('_');
    }

    return matchedAttr;
  }

  if(targets && targets.length > 0){
    targets.forEach(target => {
      const classArray = target.classList
      Object.values(classArray).forEach(function (item) {
        var splitClassResult = isMatch(item) 
        if (splitClassResult !== null) {
          // result will be of structure [pd, data-something, value]
          target.setAttribute(splitClassResult[1], splitClassResult[2]);
        }
      });    
    });
  }

}

export default DataAttrTransformer

